import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cgu',
  templateUrl: './cookies.component.html',
  styleUrls: ['./information.component.css']
})
export class CookiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
